var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitchAlt = function SvgTwitchAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.909 10.294 15.8 30.406v72.4h24.132v20.112l20.112-20.112h16.089l36.2-36.2V10.294Zm68.381 52.291L88.2 78.675H72.111L58.033 92.753V78.675h-18.1V18.339h64.357Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.178 32.418h8.045v24.134h-8.045zM62.055 32.418H70.1v24.134h-8.045z"
  }))));
};
export default SvgTwitchAlt;